import React from 'react';
import { styled } from '@mui/material/styles';
const PREFIX = 'MainBanner';

const classes = {
    root: `${PREFIX}-root`,
    textWrapper: `${PREFIX}-textWrapper`,
    text1: `${PREFIX}-text1`,
    text2: `${PREFIX}-text2`,
    icon: `${PREFIX}-icon`
};

const Root = styled('div')((
    {
        theme
    }
) => ({
    [`&.${classes.root}`]: {
        width: '100%',
        minHeight: '100vh',
        background: 'linear-gradient(90deg, #1CB5E0 0%, #000851 100%), #F18D2B',
        mixBlendMode: 'normal',
        position: 'relative',
        height: '100%',
    },

    [`& .${classes.textWrapper}`]: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        color: '#fff',
        textAlign: 'center',
        [theme.breakpoints.down('md')]: {
            width: '100%',
        },
    },

    [`& .${classes.text1}`]: {
        fontFamily: 'Roboto',
        fontWeight: 200,
        fontStyle: 'normal',
        fontSize: '60px',
        lineHeight: '60px',
        textAlign: 'center',
        [theme.breakpoints.down('md')]: {
            fontSize: '42px',
        },
        paddingLeft: '1rem',
    },

    [`& .${classes.text2}`]: {
        fontFamily: 'Roboto',
        fontWeight: 100,
        fontSize: '35px',
        textAlign: 'center',
        paddingBottom: '3px',
    },

    [`& .${classes.icon}`]: {
        display: 'inline-block',
        verticalAlign: 'middle',
        fontSize: '20px',
    }
}));

const MainBanner = () => {


    return (
        <Root className={classes.root}>
            <div className={classes.textWrapper}>
                {window.location.href.includes('lessons') && (
                    <>
                        <h3 className={classes.text1}>ARCO Lessons Learned</h3>
                        <h4 className={classes.text2}>&nbsp;
                            {/* Learn and Share Lessons from ARCO Jobsites! */}
                        </h4>
                    </>
                )}
                {!window.location.href.includes('lessons') && (
                    <>
                        <h3 className={classes.text1}>ARCO Roster</h3>
                        <h4 className={classes.text2}>
                            Manage your project teams intelligently!
                        </h4>
                    </>
                )}
            </div>
        </Root>
    );
};

export default MainBanner;
